import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import { Ref, ref, onMounted, onBeforeUnmount } from 'vue'
import i18n from '@/lang/i18n'

const VIEWPORT_BOTTOM_SPACE = 120

type Props = {
  getHeight: () => number;
  height?: number | null;
  minHeight?: number;
  maxHeight?: number | null;
  keyStep?: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'ResizeHandle',
  props: {
    getHeight: {},
    height: { default: null },
    minHeight: { default: 200 },
    maxHeight: { default: null },
    keyStep: { default: 40 }
  },
  emits: ["update:height"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const startY: Ref<number> = ref(0)
const startHeight: Ref<number> = ref(0)

const currentHeight = (): number => props.height || props.getHeight()

const clampHeight = (height: number): number => {
  const max = Math.max(props.minHeight, props.maxHeight || window.innerHeight - VIEWPORT_BOTTOM_SPACE)
  return Math.min(Math.max(Math.round(height), props.minHeight), max)
}

const resize = (event: PointerEvent) => {
  emit('update:height', clampHeight(startHeight.value + event.clientY - startY.value))
}

const removeResizeListeners = () => {
  document.removeEventListener('pointermove', resize)
  document.removeEventListener('pointerup', endResize)
  document.removeEventListener('pointercancel', endResize)
  document.body.classList.remove('resize-handle-dragging')
}

function endResize () {
  removeResizeListeners()
}

const startResize = (event: PointerEvent) => {
  const height = currentHeight()
  if (!height) {
    return
  }
  event.preventDefault()
  startY.value = event.clientY
  startHeight.value = height
  const handle = event.currentTarget as HTMLElement
  handle.setPointerCapture?.(event.pointerId)
  document.addEventListener('pointermove', resize)
  document.addEventListener('pointerup', endResize)
  document.addEventListener('pointercancel', endResize)
  document.body.classList.add('resize-handle-dragging')
}

const resizeByKey = (step: number) => {
  const height = currentHeight()
  if (!height) return
  emit('update:height', clampHeight(height + step))
}

const fitToViewport = () => {
  const height = currentHeight()
  if (!height) {
    return
  }
  const clamped = clampHeight(height)
  if (clamped < height) {
    emit('update:height', clamped)
  }
}

onMounted(() => {
  window.addEventListener('resize', fitToViewport)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', fitToViewport)
  removeResizeListeners()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "resize-handle",
    role: "separator",
    "aria-orientation": "horizontal",
    tabindex: "0",
    title: _unref(i18n).global.t('pages.common.resizeHandle'),
    onPointerdown: startResize,
    onKeydown: [
      _cache[0] || (_cache[0] = _withKeys(_withModifiers(($event: any) => (resizeByKey(props.keyStep)), ["prevent"]), ["down"])),
      _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (resizeByKey(-props.keyStep)), ["prevent"]), ["up"]))
    ]
  }, [...(_cache[2] || (_cache[2] = [
    _createElementVNode("span", { class: "resize-handle__grip" }, null, -1)
  ]))], 40, _hoisted_1))
}
}

})